export const activityEntities = [
    {
        relatedEntityId: 1,
        relatedEntity: "Patient Overview",
    },
    {
        relatedEntityId: 2,
        relatedEntity: "Assessment",
    },
    {
        relatedEntityId: 3,
        relatedEntity: "Care Plan",
    },
    {
        relatedEntityId: 4,
        relatedEntity: "Notes",
    },
    {
        relatedEntityId: 5,
        relatedEntity: "Appointment",
    },
    {
        relatedEntityId: 6,
        relatedEntity: "Resources",
    },
    {
        relatedEntityId: 7,
        relatedEntity: "Activity Log",
    },
    {
        relatedEntityId: 8,
        relatedEntity: "Call Summary",
    },
    {
        relatedEntityId: 9,
        relatedEntity: "Outbound Call",
    },
    {
        relatedEntityId: 10,
        relatedEntity: "Sms",
    },
]
